export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 32;

export const PASSWORD_RULES = [
  {
    id: 'minLength',
    label: 'En az 8 karakter',
    test: (v) => v.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: 'maxLength',
    label: 'En fazla 32 karakter',
    test: (v) => v.length <= PASSWORD_MAX_LENGTH,
  },
  {
    id: 'uppercase',
    label: 'En az 1 büyük harf',
    test: (v) => /[A-Z]/.test(v),
  },
  {
    id: 'lowercase',
    label: 'En az 1 küçük harf',
    test: (v) => /[a-z]/.test(v),
  },
  {
    id: 'digit',
    label: 'En az 1 rakam',
    test: (v) => /\d/.test(v),
  },
  {
    id: 'special',
    label: 'En az 1 özel karakter',
    test: (v) => /[^a-zA-Z0-9]/.test(v),
  },
];

export function evaluatePasswordRules(password) {
  const value = String(password || '');
  return PASSWORD_RULES.map((rule) => ({
    ...rule,
    passed: rule.test(value),
  }));
}

export function isPasswordValid(password) {
  return evaluatePasswordRules(password).every((rule) => rule.passed);
}
